import React, { useRef } from "react";
import { FaAngleLeft } from "react-icons/fa";
import { Link, useNavigate, useParams } from "react-router-dom";
import arrow from "../../Assets/img/dowArrow.png";
import grid from "../../Assets/img/gridWhite.png";
import logo from "../../Assets/img/LogoMMASM.png";
import rdIcon from "../../Assets/img/rdIcon.png";
import worldIcon from "../../Assets/img/world.png";
import AppFooter from "../../Components/AppFooter";
import { Navbar } from "../../Components/Navbar";
import useComponentVisible from "../../Context/hook/useComponentVisible";
import ScrollToTop from "../../Components/ScrollToTop";
import useUser from "../../Context/hook/useUser";
import { authMenuSinap, noAuthMenuSinap } from "../../Utils/constants.api";
import { useQuery } from "react-query";
import axios from "axios";
import { Loading } from "../../Components/LoadingComponent";
import { URL } from "../../Utils/url.api";
import { useDispatch } from "react-redux";
import { uiActions } from "../../store/ui";

function MainHeader(props) {
  const { ref, isComponentVisible, toggle } = useComponentVisible(false);
  const navigate = useNavigate();
  const toHome = () => {
    navigate("/");
  };

  return (
    <>
      <div ref={ref} className="relative">
        <div
          style={{
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            position: "absolute",
            zIndex: 1,
          }}
          className={`w-[100vw] h-[100vh]`}
        >
          <nav style={{ zIndex: 2 }} className={`mt-10 mx-10 absolute`}>
            <div className="text-white w-[90vw] tab-port:w-[95vw]  flex flex-row space-x-4">
              <Link to={`/catalog/`} className="flex items-center">
                <FaAngleLeft className="icono hover:text-stone-400" />
              </Link>
              <img
                className="w-20 cursor-pointer"
                onClick={toHome}
                src={logo}
                alt=""
              />
              <div
                className="h-10 w-[0.1em] my-auto bg-white cursor-pointer"
                onClick={toHome}
              >
                .
              </div>
              <div className="text-lg my-auto cursor-pointer" onClick={toHome}>
                <p onClick={toHome}>Sistema nacional de</p>
                <span className="font-bold cursor-pointer" onClick={toHome}>
                  Áreas Protegidas
                </span>
              </div>
              <button onClick={() => toggle(true)}>
                <img
                  className="w-16 h-16 absolute right-0 top-1/2 -translate-y-1/2 transform"
                  src={grid}
                  alt=""
                />
              </button>
            </div>
          </nav>

          <header className="tab-port:max-w-[60em] text-center absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2">
            <h1 className="font-bold text-white text-[5em]">{props.title}</h1>
            {!props.disabled && (
              <button
                onClick={() => navigate(`/detail/payment/${props.id}`)}
                className="mt-10 hover:bg-[#fff] hover:text-black mx-auto my-auto text-xl rounded-full border-2 text-[#fff] border-[#fff] w-fit px-10 py-4"
              >
                Comprar
              </button>
            )}
          </header>

          <div className="absolute bottom-16 right-16">
            <button onClick={() => props.scroll()}>
              <p className="animate-bounce font-bold text-white">
                Bajar <img className="w-10 inline" src={arrow} alt="" />
              </p>
            </button>
          </div>
        </div>
        <div
          style={{
            backgroundImage: `url(${props.bg})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            position: "relative",
            zIndex: 0,
          }}
          className={`w-[100vw] h-[100vh]`}
        ></div>
        <Navbar
          active={isComponentVisible}
          toggle={toggle}
          authMenu={authMenuSinap}
          noAuthMenu={noAuthMenuSinap}
        ></Navbar>
      </div>
    </>
  );
}

function ParkDescription(props) {
  return (
    <>
      <div
        ref={props.componentRef}
        className="w-[100vw] h-[100vh] flex items-center"
      >
        <div className="max-w-[80vw] text-center tab-port:text-left mx-auto flex flex-col tab-port:space-x-20 tab-port:flex-row">
          <img
            className="tab-port:w-[65em] tab-port:h-[40em] my-auto"
            src={props.map}
            alt="Mapa de la zona"
          />
          <div className="bg-[#003670] invisible  tab-port:visible tab-port:w-2">
            .
          </div>
          <div className="tab-port:max-w-[32vw]">
            <h1 className="font-bold text-[5em] leading-snug">
              {props.description}
            </h1>
            <h6 className="font-medium text-2xl leading-snug">
              {props.description2}
            </h6>
            <p className="text-lg mt-5 text-[#808080]">{props.description3}</p>
          </div>
        </div>
      </div>
    </>
  );
}

function Card(props) {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  return (
    <>
      <div className="bg-white w-[40em] h-[50vh] tab-port:w-[35em] tab-port:h-[50em] rounded-lg flex flex-col text-center">
        <img className="w-40 mx-auto my-16" src={props.icon} alt={props.icon} />
        <h1 className="font-base text-4xl">{props.title}</h1>
        <p className="mt-5 text-lg">Individual</p>

        <p className="mt-10">
          <span className="font-medium text-4xl">${props.price}</span>/p.p
        </p>

        <p className="mt-8 mx-auto max-w-[40vw] tab-port:max-w-[15vw]">
          Para acceder a nuestras áreas protegidas se requiere ticket de
          entrada.
          <Link to={"/politicas"}>
            <span className="ml-1 text-font-light link">
              Ver Políticas de Privacidad y Términos de Uso.
            </span>
          </Link>
        </p>
        {!props.disabled && (
          <button
            onClick={() => {
              dispatch(
                uiActions.wasFromPay({ conditional: true, parkId: props.id })
              );
              navigate(`/detail/payment/${props.id}`);
            }}
            className="hover:bg-[#003670] hover:text-white mx-auto my-auto text-xl rounded-full border-2 text-[#003670] border-[#003670] w-fit px-10 py-4"
          >
            Comprar
          </button>
        )}
      </div>
    </>
  );
}

function Prices(props) {
  //Logica para saber si el usuario es extranjero o dominicano
  const { isAuth, getUser } = useUser();

  const PriceCards = () => {
    if (isAuth()) {
      return getUser()?.clientTypeId === "C" ? (
        <Card
          id={props.id}
          price={props.priceRD}
          icon={rdIcon}
          fare="priceRD"
          title="Dominicano"
          disabled={props.disabled}
        />
      ) : getUser()?.clientTypeId === "TO" ? (
        <Card
          id={props.id}
          price={props.priceTO}
          icon={rdIcon}
          fare="priceRD"
          title="Tour Operador"
          disabled={props.disabled}
        />
      ) : (
        <Card
          id={props.id}
          price={props.priceEX}
          icon={worldIcon}
          fare="priceEX"
          title="Extranjero"
          disabled={props.disabled}
        />
      );
    }
    return (
      !isAuth() && (
        <>
          <Card
            id={props.id}
            price={props.priceRD}
            icon={rdIcon}
            fare="priceRD"
            title="Dominicano"
            disabled={props.disabled}
          />
          <Card
            id={props.id}
            price={props.priceEX}
            icon={worldIcon}
            fare="priceEX"
            title="Extranjero"
            disabled={props.disabled}
          />
        </>
      )
    );
  };

  return (
    <>
      <div className="mx-auto w-[100vw] h-[110vh] tab-port:w-[95vw] tab-port:h-[95vh] bg-[#003670] flex flex-row tab-port:rounded-[2em] mb-20">
        <div className="my-auto max-w-fit mx-auto space-y-10 tab-port:space-y-0 flex flex-col tab-port:flex-row tab-port:space-x-48 items-center">
          <PriceCards />
        </div>
      </div>
    </>
  );
}

function Activities(props) {
  return (
    <>
      <div className="w-[100vw] mb-80 tab-port:mb-0 tab-port:h-[80vh] h-[100vh] tab-port:relative">
        <div className="max-w-[90vw]">
          <h1 className="mt-10 ml-40 text-[5em] font-bold">Actividades</h1>
        </div>
        <div
          className="items-center mt-10 tab-port:mt-0 tab-port:absolute tab-port:top-1/2 tab-port:left-1/2 tab-port:transform tab-port:-translate-x-1/2 tab-port:-translate-y-1/2
            flex flex-col tab-port:flex-row tab-port:space-x-10"
        >
          {props.activities.map((value) => {
            return (
              <div
                key={value.id}
                className="w-[43em] h-[40em] text-center tab-port:text-left"
              >
                <img
                  className="h-[22em] mx-auto tab-port:mx-0"
                  src={value.photo}
                  alt={value.photo}
                />
                <h1 className="text-4xl my-6">{value.title}</h1>
                <p className="text-[#808080] mx-auto tab-port:mx-0 text-lg max-w-[30em]">
                  {value.description}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </>
  );
}

function ParkDetail() {
  const { id } = useParams();

  const fetchParkById = async () => {
    return await axios.get(URL + `Parque/${id}`);
  };

  const { isLoading, data, refetch } = useQuery("parkId", fetchParkById);

  const ref = useRef(null);

  if (isLoading) {
    return <Loading />;
  }

  const scroll = () =>
    ref.current.scrollIntoView({ behavior: "smooth", block: "center" });

  return (
    <>
      <MainHeader
        disabled={data.data.data.disabled}
        scroll={scroll}
        bg={data.data.data?.imagenPerfil}
        title={data.data.data?.nombre}
        id={data.data.data?.id}
      />
      <ScrollToTop />
      <ParkDescription
        componentRef={ref}
        map={data.data.data?.imagenMapa}
        description={data.data.data?.description.title}
        description2={data.data.data?.description.description}
        description3={data.data.data?.description.summary}
      />
      <Prices
        id={data.data.data?.id}
        disabled={data.data.data.disabled}
        priceEX={data.data.data?.tarifaParqueExt}
        priceRD={data.data.data?.tarifaParque}
        priceTO={data.data.data?.tarifaParqueExt}
      />
      {data.data.data?.activities?.length > 0 && (
        <Activities activities={data.data.data?.activities} />
      )}
      <AppFooter />
    </>
  );
}

export default ParkDetail;
